var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.82407 1.75H2.00926C1.86607 1.75 1.75 1.86607 1.75 2.00926V3.82407C1.75 3.96726 1.86607 4.08333 2.00926 4.08333H3.82407C3.96726 4.08333 4.08333 3.96726 4.08333 3.82407V2.00926C4.08333 1.86607 3.96726 1.75 3.82407 1.75Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9906 9.9165H10.1758C10.0326 9.9165 9.9165 10.0326 9.9165 10.1758V11.9906C9.9165 12.1338 10.0326 12.2498 10.1758 12.2498H11.9906C12.1338 12.2498 12.2498 12.1338 12.2498 11.9906V10.1758C12.2498 10.0326 12.1338 9.9165 11.9906 9.9165Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 11.0835H4.0835C3.43916 11.0835 2.91683 10.5612 2.91683 9.91683V9.3335V8.3335C2.91683 7.59712 3.51378 7.00016 4.25016 7.00016H9.75016C10.4865 7.00016 11.0835 6.40321 11.0835 5.66683V4.25016C11.0835 3.51378 10.4865 2.91683 9.75016 2.91683H4.66683",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.822446c5eb9313a916e5a5b22a9e7e4b.svg";
export { ForwardRef as ReactComponent };